import React, { useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { refreshJWT } from '../../services/auth';
import { useUserContext } from '../../context/user';
import { clearLocalStorage } from '../../helpers/logout';

export const TryRefreshJWT = () => {
    const { setJwtToken, setJwtRefreshToken, lastPageUrl, setLastPageUrl } = useUserContext();

    const { mutate } = useMutation({
        mutationFn: refreshJWT,
        onSuccess: (data) => {
            setJwtToken(data.accessToken);
            setJwtRefreshToken(data.refreshToken);

            if (lastPageUrl) {
                window.location.replace(lastPageUrl);
                setLastPageUrl(null);
            } else {
                window.location.replace('/');
            }
        },
        onError: (error) => {
            clearLocalStorage()
            window.location.replace("/sign_in/login_password");
        }
    });

    useEffect(() => {
        const refreshToken = localStorage.getItem("xAuthRefreshToken");
        if (refreshToken) {
            mutate({ refreshToken })
        } else {
            clearLocalStorage()
            window.location.replace("/sign_in/login_password");
        }
    }, [])

    return (
        <div>
            Попытка обновления токена авторизации...
        </div>
    );
};
